// extracted by mini-css-extract-plugin
export default {"contents":"xG-z","sectionHeading":"yG-z"};